import { useEffect, useState } from "react";
import { Button, Dropdown, Skeleton, Space, Table, Tabs, Col, Row, Input, Tooltip } from "antd";

import service from "../../services/dataMigrationService";
import { recordError } from "../../utils/logService";

import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined, SearchOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { isAuthorizedRole } from "@seims/shared/src/security";
import moment from "moment";
import DownloadOverviewResults from "./DownloadOverviewResults";
import { programmes } from '../../utils/functions/apiConstants';
import { map, get } from 'lodash';

import {
  FileGeneratorProgress,
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function UploadHistory() {

    const sortDirections = ['ascend', 'descend', 'ascend'];

    const allUploads = "All Uploads";

    const [uploadedFile, setUploadedFile] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [physicalFile, setPhysicalFile] = useState({});
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [showPDF, setShowPDF] = useState(false);
    const [successful, setSuccessful] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [currentTab, setCurrentTab] = useState(programmes[0].key);
    const [searchText, setSearchText] = useState("");
    const [moduleName, setModuleName] = useState("");
      const [progress, setProgress] = useState(0);
      const [isGenerating, setIsGenerating] = useState(false);
      const [progressText, setProgressText] = useState("Generating file, please wait...");

    const [total, setTotal] = useState(0);

    useEffect(() => {
        getUploadHistory(currentTab);
    }, []);

    let msg = "";

    const onReset = () => {
        setProgress(0);
        setProgressText("Generating file, please wait...");
    };

    const tabList = [
        {
            key: programmes[0].key,
            label: "National Youth Service",
        },
        {
            key: programmes[1].key,
            label: "Events",
        },
        // {
        //     key: programmes[2].key,
        //     label: "Citizen Science"
        // },
        // {
        //     key: programmes[3].key,
        //     label: "Volunteer Scientist"
        // },
        //Fails to retrieve from the BE, WIP
        // {
        //     key: programmes[4].key,
        //     label: "STEMI Olympiad"
        // }
    ]

    const items = [
        {
            label: "PDF - Overview",
            key: "pdf-overview",
            icon: <FilePdfOutlined />,
        },
        {
            label: "EXCEL - Detailed",
            key: "exel-details",
            icon: <FileExcelOutlined />,
            disabled: successful,
            own: false,
        },
    ];

    const columns = [
        {
            title: "File Name",
            dataIndex: "filename",
            key: "filename1",
        },
        {
            title: "File Size",
            dataIndex: "fileSize",
            key: "filesize3",
            own: true
        },
        {
            title: "Upload Status",
            dataIndex: "overallStatus",
            key: "overallStatus4",
            sorter: (a, b) => a.overallStatus.localeCompare(b.overallStatus),
            sortDirections: sortDirections,
        },
        {
            title: "Uploaded Date",
            dataIndex: "uploadDate",
            key: "4uploadDate",
            render: (text) => {
                return text != null ? moment(text).format("DD MMM YYYY, HH:mm") : "";
            },
            sorter: (a, b) => a.uploadDate.localeCompare(b.uploadDate),
            sortDirections: sortDirections,
        },
        {
            title: "Download File",
            dataIndex: "file",
            key: "6downloadFile",
            own: true,
            align: "center",
            render: (_, record) => {
                const { fileUuid, filename } = record;
                if (record.id > 0) {
                    return (
                        <Space>
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={() => handleFileDownload(fileUuid, filename)}
                            />
                        </Space>
                    );
                }
            },
        },
        {
            title: "Download report",
            dataIndex: "download",
            key: "7downloadReport",
            align: "center",
            render: (_, record) => {
                const { reportUuid } = record;
                if (record.id > 0) {
                    return (
                        <Space>
                            <Dropdown
                                menu={{
                                    items: items.map((item) => ({
                                        ...item,
                                        disabled:
                                            item.key === 'exel-details' &&
                                            record.overallStatus === 'Data Upload Successful',
                                    })),
                                    onClick: ({ key }) => {
                                        handleMenuClick(key, reportUuid);
                                    },
                                }}
                            >
                                <Space>
                                    <Tooltip title="View download options">
                                        <Button type="primary">
                                            <FilePdfOutlined />
                                        </Button>
                                    </Tooltip>
                                </Space>
                            </Dropdown>
                        </Space>
                    );
                }
            },
        },
        {
            title: "Uploader",
            dataIndex: "user",
            key: "uploader",
            uploader: true,
            sorter: (a, b) => a.user.localeCompare(b.user),
            sortDirections: sortDirections,
        },
    ]
    // .filter((item) => {
    //     return isAuthorizedRole(["PROGRAMME_LEAD", "ADMIN", "NYS_DATA_UPLOADER", "EVENTS_DATA_UPLOADER"]) ? item : item.uploader === undefined
    // });

    const handleMenuClick = async (key, reportUuid) => {

        if (key === "pdf-overview") {
            onPDFDownload(reportUuid);
        } else if (key === "exel-details") {
            onDownloadExcel(reportUuid);

        }
    }

    const generateEXCEL = async (dataFile) => {

        if (!dataFile || dataFile.length == 0) {
            return;
        }
        const { details: reportData, fileDetails } = dataFile;

        const response = await service.downloadOriginalFile(fileDetails.uuid, moduleName);
        if (response) {
            const { data } = response;
            const blobFile = new Blob([data], { type: 'application/octet-stream' });
            // setPhysicalFile(blobFile);

            await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                setIsGenerating(true);

                fileReader.readAsArrayBuffer(blobFile);
                fileReader.onload = async (e) => {
                    const bufferArray = e.target.result;
                    const wb = XLSX.read(bufferArray, { type: "buffer" });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    // const data = XLSX.utils.sheet_to_json(ws);

                    let colAlias = "";

                    for (let rowIndex = 0; rowIndex < reportData.length; rowIndex++) {
                        //START FROM COLUMN A (StemiName) - COLUMN R (LEARNER RESULTS)
                        if (reportData[rowIndex].col === 0) colAlias = "A";
                        if (reportData[rowIndex].col === 1) colAlias = "B";
                        if (reportData[rowIndex].col === 2) colAlias = "C";
                        if (reportData[rowIndex].col === 3) colAlias = "D";
                        if (reportData[rowIndex].col === 4) colAlias = "E";
                        if (reportData[rowIndex].col === 5) colAlias = "F";
                        if (reportData[rowIndex].col === 6) colAlias = "G";
                        if (reportData[rowIndex].col === 7) colAlias = "H";
                        if (reportData[rowIndex].col === 8) colAlias = "I";
                        if (reportData[rowIndex].col === 9) colAlias = "J";
                        if (reportData[rowIndex].col === 10) colAlias = "K";
                        if (reportData[rowIndex].col === 11) colAlias = "L";
                        if (reportData[rowIndex].col === 12) colAlias = "M";
                        if (reportData[rowIndex].col === 13) colAlias = "N";
                        if (reportData[rowIndex].col === 14) colAlias = "O";
                        if (reportData[rowIndex].col === 15) colAlias = "P";
                        if (reportData[rowIndex].col === 16) colAlias = "Q";
                        if (reportData[rowIndex].col === 17) colAlias = "R";

                        const currRow = reportData[rowIndex].row + 1;
                        const cell = ws[colAlias + currRow];

                        if (cell) {
                            XLSX.utils.cell_add_comment(
                                cell,
                                reportData[rowIndex].message,
                                "CSIR"
                            );
                        }
                    }

                    const range = XLSX.utils.decode_range(ws["!ref"]);


                    for (let i = range.s.r; i <= range.e.r; i++) {
                        if ((i / range.e.r) * 100 < 99) {
                            await new Promise((resolve) => setTimeout(resolve, 0));
                            setProgress(Math.round((i / range.e.r) * 100));
                        }

                        for (let j = range.s.c; j <= 18; j++) {
                            const cell = ws[XLSX.utils.encode_cell({ r: i, c: j })];

                            const errorFound = reportData.filter(
                                (current) => current.row === i && current.col === j
                            );

                            if (cell && errorFound.length > 0) {
                                cell.s = { fill: { fgColor: { rgb: "ffff00" } } };
                            }
                        }
                    }
                    setProgressText("Downloading file...");

                    const workbook = XLSX.utils.book_new();

                    XLSX.utils.book_append_sheet(workbook, ws, wsname);

                    const fileInfo = fileDetails.filename.split(".");
                    const lastIndex = fileInfo.length - 1;
                    XLSX.writeFile(
                        wb,
                        `${fileInfo[0]}_WITH_COMMENTS.${fileInfo[lastIndex]}`
                    );

                    setProgress(100);

                    if (dataFile.length > 0) {
                        resolve(dataFile);
                        setProgressText("Done");

                        if (!isGenerating) {
                            onReset();
                        }
                    }
                    setIsGenerating(false);
                };
                FileReader.onerror = (error) => {
                    reject(error);
                    setLoading(true);
                    setIsGenerating(false);
                };
            });
        }
    }

    const onPDFDownload = async (reportUuid) => {
        try {
            const response = await service.downloadOverviewReport(reportUuid, moduleName);
            if (response && response.status === 200) {
                const { data } = response;

                if (data.overallStatus === "Data Upload Failed") {
                    setShowPDF(true);
                    setReportData(data);
                    setSuccessful(false);
                } else {
                    setShowPDF(true);
                    setReportData(data);
                    setSuccessful(true);
                }
            }
        } catch (error) { }
    };

    const onDownloadExcel = async (reportUuid) => {

        const response = await service.downloadReport(reportUuid, moduleName);
        if (response && response?.status === 200) {
            const { data } = response;
            if (data.overallStatus === "Data Upload Failed") {
                setReportData(data);
                setSuccessful(false);
            } else {
                setReportData(data);
                setSuccessful(true);
            }
            generateEXCEL(data);
        };
    }

    const onTabChange = (selectedTab) => {

        setCurrentTab(selectedTab);
        getUploadHistory(selectedTab);
    };

    const getUploadHistory = async (currentTab) => {

        let mName = '';
        if (isAuthorizedRole(["NYS_DATA_UPLOADER"])) {
            mName = (programmes.find(c => c.key === 'nys-programme').key);
        }
        else if (isAuthorizedRole(["EVENTS_DATA_UPLOADER"])) {
            mName = (programmes.find(c => c.key === 'events-tracker').key);
        }
        else if (isAuthorizedRole(["CS_DATA_UPLOADER"])) {
            mName = (programmes.find(c => c.key === 'citizen-science').key);
        } else if (isAuthorizedRole(["PROGRAMME_LEAD", "ADMIN"])) {
            mName = currentTab;
        }
        else {
            mName = (programmes.find(c => c.key === 'volunteer-scientist').key);
        }
        setModuleName(mName);
        const entity = "file";
        setUploadedFile([]);
        try {
            setLoading(true);
            //We may need to revert to this in the future, should the business state otherwise. 
            const response =
                // (isAuthorizedRole(["PROGRAMME_LEAD", "ADMIN"])) ? await service.getUploadOwnHistory(currentTab,false) : 
                await service.getUploadOwnHistory(mName, false)

            if (response && response.status === 200) {

                let fileData = [];
                const { data } = response;

                fileData = data.map((element) => ({
                    fileUuid: element.uploadedFile.uuid.toString(),
                    reportUuid: element.uploadReport.uuid.toString(),
                    id: element.uploadedFile.id,
                    overallStatus: element.overallStatus,
                    filename: element.uploadedFile.filename,
                    fileSize: `${Math.round(element.uploadedFile.fileSize / 1024, 0)}KB`,
                    uploadDate: element.uploadDate,
                    user: element.ownRecord ? "Me" :
                        element.userDetails?.firstname + " " + element.userDetails?.surname,
                    own: element.ownRecord,
                }));
                setUploadedFile(fileData);
                setFilteredData(fileData);
                setTotal(fileData.length);

                setLoading(false);
            } else if (response && response.status === 204) {
                setLoading(false);
                setUploadedFile([]);
                setFilteredData([]);
            } else {
                setUploadedFile([]);
                setFilteredData([]);
            }
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE, entity);
            openNotification(
                "System failed to load uploaded file details",
                msg,
                Notify.ERROR
            );
            recordError(error);
        }
    };

    const handleFileDownload = async (fileUuid, filename) => {
        try {
            const response = await service.downloadOriginalFile(fileUuid, moduleName);
            if (response) {
                const { data } = response;
                setPhysicalFile(data);
                const new_blob = new Blob([data]);

                const url = URL.createObjectURL(new_blob);
                const downloadLink = document.createElement("a");

                downloadLink.href = url;
                downloadLink.download = filename;
                downloadLink.click();
                URL.revokeObjectURL(url);
            }
        } catch (error) {
            msg = util.parseMessage(Messages.FILEDOWNLOAD_FAILURE, "File");
            openNotification("File Download", msg, Notify.ERROR);

            recordError(error);
        }
    };

    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };

    const handleCancel = () => {
        setShowPDF(false);
    };

    const handleInputChange = (e) => {
        const { value: searchValue } = e.target;
        setSearchText(searchValue);
        globalSearch(searchValue);
    };

    const globalSearch = (searchValue) => {
        if (searchValue === "") {
            setFilteredData(uploadedFile);
            setCurrentPage(1);
            return;
        }

        const reg = new RegExp(
            searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
            "gi"
        );

        const _filteredData = map(uploadedFile, (record) => {
            const filenameMatch = get(record, "filename").match(reg);
            const answerMatch = get(record, "user").match(reg);

            if (!filenameMatch && !answerMatch) {
                return null;
            }
            return record;
        }).filter((record) => record);

        setSearchText(searchValue);
        setFilteredData(_filteredData);
        setCurrentPage(1); // Reset to first page
    };

    const title = "History of data uploaded";
    const subTitle = "List of previously uploaded files";

    return (
        <div className="content">
            <h1 className="center-align">{title}</h1>
            <div>{subTitle}</div>
            <Row>
                <Col xs={24} md={8}>
                    <Input
                        placeholder="Start typing to filter documents by File Name or User"
                        type="text"
                        className="search-bar"
                        onChange={handleInputChange}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                        name=''
                    />
                </Col>
            </Row>
            <div className="space"></div>
            {isAuthorizedRole(["PROGRAMME_LEAD","ADMIN"]) && (
                <Tabs
                    type="card"
                    className="event-information"
                    items={tabList}
                    key="1"
                    onChange={onTabChange}
                />
            )}
            {loading ? (
                <Skeleton active avatar />
            ) : (
                <Table
                    dataSource={filteredData}
                    columns={columns}
                    loading={loading}
                    rowKey={(record) => "Upload-" + record.id}
                    bordered
                    size="middle"
                    onChange={onRowChange}
                    pagination={{
                        total: filteredData.length,
                        onChange: (page, pageSize) => {
                            setCurrentPage(page); // manage current page in state
                            setPageSize(pageSize);
                        },
                        showSizeChanger: true,
                        showQuickJumper: true,
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total > 1 ? 'Uploads' : 'Upload'}`
                    }}
                />
            )}
            <DownloadOverviewResults
                show={showPDF}
                successful={successful}
                onCancel={handleCancel}
                data={reportData}
            />
             <FileGeneratorProgress progressText={progressText} progress={progress} setProgress isGenerating={isGenerating} />
        </div>
    );
}
